module.exports = __webpack_public_path__ + "static/media/android-mock.49558659.svg";